export default "__VITE_ASSET__BOD5Xu$j__"